// @flow
import { TeamPreferences } from 'common/models/internal/TeamPreferences';

export const getIsTeamPreferencesLoading = (state): boolean => {
    return state.teamPreferences.get('isLoading');
};

export const getTeamPreferences = (state): ?TeamPreferences => {
    return state.teamPreferences.get('value');
};
